import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/stores/authStore';
import type { SupportedLanguage } from '@/i18n';

const MKEY_API = 'https://mkey-api-production.fidelismadboat.workers.dev';

const FLAGS: Record<SupportedLanguage, string> = {
  'pt-BR': '🇧🇷',
  'en-US': '🇺🇸',
};

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const token = useAuthStore((s) => s.token);

  const currentLang = (i18n.language || 'pt-BR') as SupportedLanguage;
  const nextLang: SupportedLanguage = currentLang === 'pt-BR' ? 'en-US' : 'pt-BR';

  const handleToggle = async () => {
    // Change language locally (instant)
    i18n.changeLanguage(nextLang);
    localStorage.setItem('madboat-language', nextLang);

    // Persist to backend (fire-and-forget)
    if (token) {
      fetch(`${MKEY_API}/user/language`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ language: nextLang }),
      }).catch(() => {});
    }
  };

  return (
    <button
      className="perfil-menu-item language-switcher"
      onClick={handleToggle}
      aria-label={`Switch to ${nextLang === 'pt-BR' ? 'Português' : 'English'}`}
    >
      <span className="language-flag">{FLAGS[currentLang]}</span>
      <span>{currentLang === 'pt-BR' ? 'Português' : 'English'}</span>
      <span className="language-next">{FLAGS[nextLang]}</span>
    </button>
  );
}
